export class Division {
    id = 0;
    name = '';
    colorHex = '';
}
